declare var swal: any;
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner.service';
import { AppData } from '../../../../../models/appdata';
import { ApiResponseModel } from '../../../../../models/api_response_model';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ActorLicenseRequest, ActorLicensesInfoController } from '../../../../../models/actor/actor';
import { ActorService } from '../../../../../services/actor.service';
import { DBOperation } from '../../../../../enums/enum';

import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';
import { HCPService } from '../../../../../services/hcp.service';
//import { NgbLicensesinfoModal } from '../../Licensesinfo/modals/Licenseinfo.modal';
import { NgbActorDocsModal } from '../../modals/actordocs/actordocs.modal';
import { CustomDateTimeService } from '../../../../../services/datetime.service';


import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NGXToastrService } from '../../../../../../shared/services/toastr.service';

@Component({
  selector: 'driverv2info',
  templateUrl: './driverv2.component.html',
  styleUrls: ['./driverv2.component.scss']
})

export class DriverV2InfoComponent implements OnInit {
  @Input() ActorCode: number;
  @Input() ActorType: number;

  @Input() CanEdit: number;
  @Input() CanShow: number;

  CurrentActorLicenseRequest: ActorLicenseRequest;
  CurrentActorLicensesInfoController: ActorLicensesInfoController[];

  //
  CurrentActorEditLicenseRequest: ActorLicenseRequest;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
 
  public MaxDateV = new Date();
  public CanAdjustgetTimezoneOffset: boolean;
  public MinDateV = new Date();
  public IssueMaxDateV = new Date();



  ValidTo: NgbDateStruct;
  ValidFrom: NgbDateStruct;



  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  IssuemaxDate: NgbDateStruct;

  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService) { }


  ngOnInit() {

    this.MinDateV.setFullYear(this.MinDateV.getFullYear() - 80);
    this.MaxDateV.setFullYear(this.MaxDateV.getFullYear() + 80);
    this.maxDate = { year: this.MaxDateV.getFullYear(), month: this.MaxDateV.getMonth() + 1, day: this.MaxDateV.getDate() };
    this.minDate = { year: this.MinDateV.getFullYear(), month: this.MinDateV.getMonth() + 1, day: this.MinDateV.getDate() };
    this.IssuemaxDate = { year: this.IssueMaxDateV.getFullYear(), month: this.IssueMaxDateV.getMonth() + 1, day: this.IssueMaxDateV.getDate() };

    this.CanAdjustgetTimezoneOffset = AppData.CanAdjustgetTimezoneOffset;

    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorLicenseRequest = new ActorLicenseRequest();
    this.CurrentActorLicensesInfoController = new Array<ActorLicensesInfoController>();
    this.CurrentActorLicenseRequest.ActorCode = this.ActorCode;
   
    this.CurrentActorLicenseRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentActorEditLicenseRequest = new ActorLicenseRequest(); 
    this.CurrentActorEditLicenseRequest.ActorCode = this.ActorCode;

    this.CurrentActorEditLicenseRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    if (this.CanShow === 1) {
      this.GetActorLicensesInfoController();
    }

  }
  clearData2() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorLicenseRequest = null;
    this.CurrentActorLicenseRequest = new ActorLicenseRequest();
    this.CurrentActorEditLicenseRequest.ConditionalOperator = 1;
    this.CurrentActorLicenseRequest.ActorCode = this.ActorCode;
    this.CurrentActorLicenseRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;



  }
  clearData() {
    this.ValidFrom = null;
    this.ValidTo = null;
    this.isNew = true;
    this.isEdit = false;
    this.CurrentActorLicenseRequest = null;
    this.CurrentActorLicenseRequest = new ActorLicenseRequest();
    this.CurrentActorEditLicenseRequest.ConditionalOperator = 1;
    this.CurrentActorLicenseRequest.ActorCode = this.ActorCode;
    this.CurrentActorLicenseRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowList = false;
  

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  public onInputValidFrom(value: Date): void {

    this.CurrentActorEditLicenseRequest.ValidFrom = value;
  }
  public onInputValidTo(value: Date): void {

    this.CurrentActorEditLicenseRequest.ValidTo = value;
  }
  onCredentialTypeByGroup(event: any) {

    if (event != null) {
      
      this.CurrentActorLicenseRequest.CredentialType = event;
      //alert(this.CurrentActorLicenseRequest.CredentialType);


    }


  }
  onCredentialTypeEditByGroup(event: any) {

    if (event != null) {

      this.CurrentActorEditLicenseRequest.CredentialType = event;
      //alert(this.CurrentActorLicenseRequest.CredentialType);


    }


  }
  GetActorLicensesInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetActorLicensesInfoController(this.CurrentActorLicenseRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentActorLicensesInfoController = this.ApiResData.Result;
          
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }
  onSubmit() {
    if (this.ShowList) {

      return;
    }
    else {
      //  alert("not showing list, proceed to savve...");
    }
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorLicenseRequest.ConditionalOperator = 1;

    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorLicenseRequest.ValidFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorLicenseRequest.ValidFrom);
    //  this.CurrentActorLicenseRequest.ValidTo = this.customdatetimeservice.converToLocalTime(this.CurrentActorLicenseRequest.ValidTo);
    //}
    if (this.ValidFrom != null) {



      this.CurrentActorLicenseRequest.ValidFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorLicenseRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorLicenseInfo(this.CurrentActorLicenseRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorLicensesInfoController();
            //alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.ShowList = true;
            this.clearData2();

            
           

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
          

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
         


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
      
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
        
          this.stopRefreshing();
        }
      }
      );

  }
  ShowList: boolean = true;
  CancelUpdateOperation() {
    //alert("cancell upd op");
    this.ShowList = true;
  }
  CancelNewOperation() {
    //alert("cancell new op");
    this.ShowList = true;
  }

  edit_(EditCurrentActorLicensesInfoController: ActorLicensesInfoController) {
    this.ShowList = false;
    this.IsExpand = true;
    //alert(this.CurrentActorEditLicenseRequest.CredentialType);
    //alert(this.CurrentActorEditLicenseRequest.IssuingAuthority);
    //alert(this.CurrentActorEditLicenseRequest.CredentialType);
    this.CurrentActorEditLicenseRequest.ConditionalOperator = 2;
    this.CurrentActorEditLicenseRequest.ActorCredentialCode = EditCurrentActorLicensesInfoController.ActorCredentialCode;
    this.CurrentActorEditLicenseRequest.ActorCode = EditCurrentActorLicensesInfoController.ActorCode;
    this.CurrentActorEditLicenseRequest.CredentialTypeCode = EditCurrentActorLicensesInfoController.CredentialTypeCode;
    this.CurrentActorEditLicenseRequest.CredentialType = EditCurrentActorLicensesInfoController.CredentialType;
    this.CurrentActorEditLicenseRequest.CredentialNumber = EditCurrentActorLicensesInfoController.CredentialNumber;
    this.CurrentActorEditLicenseRequest.ValidFrom = EditCurrentActorLicensesInfoController.ValidFrom;
    this.CurrentActorEditLicenseRequest.ValidTo = EditCurrentActorLicensesInfoController.ValidTo;
    
    

    if (this.CurrentActorEditLicenseRequest.ValidFrom != null) {
      var SValidFrom = new Date(this.CurrentActorEditLicenseRequest.ValidFrom);
      if (SValidFrom.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidFrom = {

          year: SValidFrom.getFullYear(),
          month: SValidFrom.getMonth() + 1,
          day: SValidFrom.getDate()
        }
      }
    }


    if (this.CurrentActorEditLicenseRequest.ValidTo != null) {
      var SValidTo = new Date(this.CurrentActorEditLicenseRequest.ValidTo);
      if (SValidTo.getFullYear() > 1900) {
        console.log('this.ValidFrom >1990');
        this.ValidTo = {

          year: SValidTo.getFullYear(),
          month: SValidTo.getMonth() + 1,
          day: SValidTo.getDate()
        }
      }
    }

    this.CurrentActorEditLicenseRequest.IssuingAuthority = EditCurrentActorLicensesInfoController.IssuingAuthority;
    this.CurrentActorEditLicenseRequest.AdditionalDetails = EditCurrentActorLicensesInfoController.AdditionalDetail;
    this.CurrentActorEditLicenseRequest.Remarks = EditCurrentActorLicensesInfoController.Remarks;

    this.isNew = false;
    this.isEdit = true;


  }
  onEditSubmit() {
    if (this.ShowList)
      return;
    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorEditLicenseRequest.ConditionalOperator = 2;
    //if (this.CanAdjustgetTimezoneOffset === true) {
    //  this.CurrentActorEditLicenseRequest.ValidFrom = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditLicenseRequest.ValidFrom);
    //  this.CurrentActorEditLicenseRequest.ValidTo = this.customdatetimeservice.converToLocalTime(this.CurrentActorEditLicenseRequest.ValidTo);
    //}

    if (this.ValidFrom != null) {



      this.CurrentActorEditLicenseRequest.ValidFrom = new Date(this.parserFormatter.format(this.ValidFrom));;
    }
    if (this.ValidTo != null) {



      this.CurrentActorEditLicenseRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));;
    }

    this.hcpservice.SaveActorLicenseInfo(this.CurrentActorEditLicenseRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.GetActorLicensesInfoController();
            //alertFunctions.AlertParam('Update Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Updated Successfully.....!');
            this.ShowList = true;
            this.clearData2();

           


            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");


            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }




  del_(ActorCredentialCode: any) {
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      buttonsStyling: false
    }).then(() => {



      this.DeleteActorIdentities(ActorCredentialCode);
     // alertFunctions.AlertParam('Deleted Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })
  }
  DeleteActorIdentities(ActorCredentialCode: any) {


    console.log('..................');
    this.StartRefreshing();
    this.CurrentActorLicenseRequest.ConditionalOperator = 3;
    this.CurrentActorLicenseRequest.ActorCredentialCode = ActorCredentialCode;
    this.hcpservice.SaveActorLicenseInfo(this.CurrentActorLicenseRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {

            this.clearData2();
            //alertFunctions.AlertParam('Deleted Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
            this.ShowList = true;




            this.stopRefreshing();
            this.GetActorLicensesInfoController();
          }
          else {
            this.stopRefreshing();
            alertFunctions.AlertParam("Invalid Operation...!");
          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);

          this.stopRefreshing();
        }
      }
      );

  }

 
  openDocContent(ActorDocCode: any) {
    if (ActorDocCode > 0) {

      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal, options)//.result(result => { this.GetActorProfileController();});
      modalRef.componentInstance.ActorDocCode = ActorDocCode;
      modalRef.componentInstance.CanEdit = this.CanEdit;
      modalRef.componentInstance.CanShow = this.CanShow;
      //modalRef.result.then(x => { this.GetActorIdentitiesController() })
    }
    else {
      alertFunctions.AlertParam('No permission to Upload Doc For this Record...!');
    }
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
